import { createSlice } from '@reduxjs/toolkit';
import { PlaybookType } from '../../constants/agents/playbooks';

// Create a Redux slice for the 'app' portion of the state
export const appSlice = createSlice({
  name: 'app', // The name of the slice
  initialState: {
    isDarkTheme: false, // Initial state for the 'isDarkTheme' property
    iframeRefresh: false,
    hasCreditAccess: true,
    userConfigData: null,
    subscribedPlaybooks: [],
    // False until the playbooks request settles, so screens don't treat "not loaded yet" as
    // "no playbooks" and flash the default agent list.
    subscribedPlaybooksLoaded: false,
    notificationBanner: false,
    broadcastCount: 0,
  },
  reducers: {
    // Reducer function for switching the theme
    switchTheme: state => {
      // Toggle the 'isDarkTheme' property in the state
      state.isDarkTheme = !state.isDarkTheme;
    },
    setIsDarkTheme: (state, action) => {
      state.isDarkTheme = action.payload;
    },
    setIframeRefresh: (state, action) => {
      state.iframeRefresh = action.payload;
    },
    setHasCreditAccess: (state, action) => {
      state.hasCreditAccess = action.payload;
    },
    setUserConfigData: (state, action) => {
      state.userConfigData = action.payload;
    },
    setSubscribedPlaybooks: (state, action) => {
      state.subscribedPlaybooks = action.payload;
      state.subscribedPlaybooksLoaded = true;
    },
    setSubscribedPlaybooksLoaded: (state, action) => {
      state.subscribedPlaybooksLoaded = action.payload;
    },
    setNotificationBanner: (state, action) => {
      state.notificationBanner = action.payload;
    },
    setBroadcastCount: (state, action) => {
      state.broadcastCount = action.payload;
    },
  },
});

// Export the action creator
export const {
  switchTheme,
  setIsDarkTheme,
  setIframeRefresh,
  setUserConfigData,
  setHasCreditAccess,
  setSubscribedPlaybooks,
  setSubscribedPlaybooksLoaded,
  setNotificationBanner,
  setBroadcastCount,
} = appSlice.actions;

// Export the reducer
export default appSlice.reducer;
